import { render, staticRenderFns } from "./Dealers.vue?vue&type=template&id=57ca2ab4"
import script from "./Dealers.vue?vue&type=script&lang=js"
export * from "./Dealers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports